import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
const MedicalUpdate = () => {
  let params = useParams();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "medicalup?link=" + params.id
  );
  const [link, setLink] = useState();
  const [name, setName] = useState();
  const [language, setLanguage] = useState();
  const [katalog, setKatalog] = useState();
  const [Image, setImage] = useState();
  const [tag, setTag] = useState();
  const [description, setDescription] = useState();
  const [primary, setPrimary] = useState();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const avatarHandle = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener("load", function () {
      setImage(this.result);
    });
    reader.readAsDataURL(file);
  };

  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "medicalupdate"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
        encType="multipart/form-data"
      >
        <TextField
          id="outlined-basics"
          label="Link"
          variant={"outlined"}
          fullWidth
          name="medical_link"
          onChange={(e) => setLink(e.target.value)}
          value={link}
          defaultValue={data.medical_link}
        />
        <TextField
          id="outlined-basic"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="medical_title"
          onChange={(e) => setName(e.target.value)}
          value={name}
          defaultValue={data.medical_title}
        />
        <TextField
          id="outlined-basic"
          label="Alt Başlık"
          variant={"outlined"}
          fullWidth
          name="medical_subtitle"
          onChange={(e) => setKatalog(e.target.value)}
          value={katalog}
          defaultValue={data.medical_subtitle}
        />
        <TextField
          id="outlined-basic"
          label="Öne Çıkan"
          variant={"outlined"}
          fullWidth
          name="medic_primary"
          onChange={(e) => setPrimary(e.target.value)}
          value={primary}
          defaultValue={data.medic_primary}
        />
        <input type={"text"} name="medical_id" value={data.medical_id} />
        <label for="lang">Dil:</label>
        <select
          name="medical_language"
          id="lang"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="tr-TR">tr</option>
          <option value="en-gb">en</option>
        </select>
        {Image ? (
          <img
            id="blah"
            src={Image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        ) : (
          <img
            id="blah"
            src={data.medical_image}
            alt="your image"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        )}
        <Button variant="contained" component="label">
          Resim yükle
          <input
            hidden
            accept="image/*"
            multiple
            type="file"
            name="medical_image"
            onChange={avatarHandle}
          />
        </Button>
        <p>Meta Description</p>
        <TextField
          id="outlined-basics"
          label="tags"
          variant={"outlined"}
          fullWidth
          name="medical_keywords"
          onChange={(e) => setTag(e.target.value)}
          value={tag}
          defaultValue={data.medical_keywords}
        />
        <TextField
          id="outlined-basics"
          label="description"
          variant={"outlined"}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          name="medical_description"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          defaultValue={data.medical_description}
        />
        <Button variant="outlined" type="submit">
          Güncelle
        </Button>
      </Box>
      <Box     
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
      >
       
        <Button variant="outlined" onClick={handleClickOpen} color="error" style={{}}>
          Sil
        </Button>
        <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "medicaldelete.php"}
      >
         <input type={"hidden"} name="medical_id" value={data.medical_id} />
        <DialogTitle id="alert-dialog-title">
          {"Silmek İstediğinize Emin Misiniz?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bu işleme onay verdiğinizde, seçili öğeler kalıcı olarak silinir ve
            hiçbir şekilde geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>İptal</Button>
          <Button onClick={handleClose} autoFocus color="error" type="submit">
            Onayla
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </>
  );
};

export default MedicalUpdate;
